import styles from './Container.module.scss'
import cn from 'classnames'

export function Container({
  screenHeight = false,
  withPattern = false,
  withoutPads = false,
  withoutPadsOnMob = false,
  children
}) {
  const classes = cn({
    [styles.container]: true,
    [styles.container_screen_h]: screenHeight,
    [styles.container_with_pattern]: withPattern,
    [styles.container_without_pad_mob]: withoutPadsOnMob,
    [styles.container_without_pad]: withoutPads
  })

  return (
    <div className={classes}>
      <div>
        {children}
      </div>
    </div>
  )
}
